import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import fr from './locales/fr/translation.json';
import it from './locales/it/translation.json';

export const defaultNamespace = 'default';

export const resources = {
  en: {
    [defaultNamespace]: en,
  },
  fr: {
    [defaultNamespace]: fr,
  },
  it: {
    [defaultNamespace]: it,
  },
};

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    defaultNS: defaultNamespace,
    ns: [defaultNamespace],
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
